export default __webpack_public_path__ + "static/media/IconCO2.ab6bb26e.svg";